/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.NotificationSetting {
    "use strict";

  export class NotificationSettingContext extends Meevo.Components.CommonClasses.CommonContextBase {
    protected addSecurityKey: string;
    protected editSecurityKey: string;
    protected copySecurityKey: string;
    protected deleteSecurityKey: string;
    protected changeAccessSecurityKey: string;
    protected changeOwnerSecurityKey: string;
    protected businessType: any;
    protected templateNotifcations: any;
    protected loading: boolean;
    private businessType_TId: Meevo.Model.DataDetail;
    protected disableTemplateChoice: boolean;
    protected apptConfirmationSendDaysBeforeList: any;
    protected apptReminderSendDaysBeforeList: any;
    protected businessInfo: any;
    protected businessSettings: any;
    public auditNoun: Meevo.Model.NounEnum;
    public isAllowedTwoWaySms: boolean = false;
    public clientAppointmentConfirmationOptionsSettings: Meevo.Model.ClientAppointmentConfirmationOptionsSettings;
    public originalModelNotificationSetting: Meevo.Model.NotificationSetting;
    public isBulkUpdateAllowed: boolean = false;

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.CommonClasses.ICommonDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      public $translate: angular.translate.ITranslateService,
      protected $http: angular.IHttpService,
      protected contextParams?: Meevo.IContextParams) {
        super(appSettings, dataService, modalService, identityService, loggingService, securityChecker);
        this.baseEndpoint = appSettings.API_ENDPOINTS.notificationSetting;
        // initialize templatepaths
        this.sectionTemplatePath = "app/plugins/notificationSetting/sectionViews/";
        this.initializeSections();
        this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN, true);
        this.auditNoun = Meevo.Model.NounEnum.NotificationSetting;
    }

    initializeSections(): void {
      // Adding sections items that represent areas in the maintenance form
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new MainSection(
                this.isApplicationModeCO(),
                this.isSingleLocation(),
                0,
                "SECTION_NOTIFICATION_SETTING_MAIN",
                "main.html",
                true,
                false,
                this.baseEndpoint,
                "",
                this.loggingService,
                this.dataService,
                Meevo.Model.NounEnum.NotificationSettingMain,
                this.identityService,
                this.$translate,
                this.modalService,
                this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new ClientAppointmentsSection(
                this.isApplicationModeCO(),
                this.isSingleLocation(),
                1,
                "SECTION_NOTIFICATION_SETTING_CLIENT",
                "clientAppointments.html",
                true,
                false,
                this.baseEndpoint,
                "",
                this.loggingService,
                this.dataService,
                Meevo.Model.NounEnum.NotificationSettingMain,
                this.identityService,
                this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new ClientMiscellaneousSection(
                this.isApplicationModeCO(),
                this.isSingleLocation(),
                2,
                "SECTION_NOTIFICATION_SETTING_CLIENT_MISC",
                "clientMiscellaneous.html",
                true,
                false,
                this.baseEndpoint,
                "",
                this.loggingService,
                this.dataService,
                Meevo.Model.NounEnum.NotificationSettingMain,
                this.identityService,
                this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new EmployeeAppointmentsSection(
                this.isApplicationModeCO(),
                this.isSingleLocation(),
                3,
                "SECTION_NOTIFICATION_SETTING_EMPLOYEE",
                "employeeAppointments.html",
                true,
                false,
                this.baseEndpoint,
                "",
                this.loggingService,
                this.dataService,
                Meevo.Model.NounEnum.NotificationSettingMain,
                this.identityService,
                this.securityKeys.BUSINESSINFO_NOTIFICATIONS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

        this.isAllowedTwoWaySms = this.securityChecker.hasSecurity(this.securityKeys.NOTIFICATIONS_SMS_ACTION_ALLOWTWOWAY);
        this.getBusinessType();
        this.getBusinessInfo();
        this.getSettings(Model.BusinessSettingCategoryEnum.Notification, true);
        this.getSettings(Model.BusinessSettingCategoryEnum.Clients, true);
        this.preActivate(this.contextParams);
    }

    preActivate(contextParams: Meevo.IContextParams): void {
        const initialSection = contextParams && contextParams.params && contextParams.params.initialEditSection;
        if (initialSection) {
            const indexOfInitialSection = this.sections.findIndex(section => section.displayNameContentKey === initialSection);
            this.processActivate(indexOfInitialSection);
            return;
        }

        this.activate();
    }

    processActivate(indexOfInitialSection: number): void {
        if (indexOfInitialSection > -1) {
            this.selectSection(this.sections[indexOfInitialSection]);
            this.initializeForEdit();
        } else {
            this.activate();
        }
    }

    selectSection(item): void {
        if (item == this.selectedSection)
            return;
        if (this.selectedSection && this.navigationBlocked) {
            if (this.selectedSection !== item) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            }
            else {
                this.modalService.alert("MESSAGE_PENDING_TAB_CHANGES");
            }
            this.selectSection(this.selectedSection);
        } else {
            this.selectedSection = item;

            if (!this.selectedSection.handlesOwnCrud) {
                this.loadingInProgress = true;

                if (this.isApplicationModeCO()) {
                    this.loadNotificationSettingByBusinessType(this.businessType_TId, true);
                }
                else {
                    this.loadNotificationSettingByBusinessType(null, true);
                }
            }

            this.selectedSection.selected();

            this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
        }
    }

    protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
      this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
      this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
      this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
      this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

    }

    initializeHeader(model: any): void {
        let notificationSetingModel = <Meevo.Model.NotificationSetting>model;
        this.headerContent = notificationSetingModel.name;
        this.originalModelNotificationSetting = angular.copy(notificationSetingModel);

        if (this.securityKeys.BUSINESSINFO_NOTIFICATIONTEMPLATE_FIELD_TEMPLATE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE) {
            this.disableTemplateChoice = false;
        }
        else {
            this.disableTemplateChoice = false;
        }
    }

    loadNotificationSettingByBusinessType(businessType?: any, isSectionSelected = false) {

        if (!isSectionSelected && (businessType == null || businessType.id == null)) {
            return;
        }

        if (businessType != null && businessType.id != null && !Meevo.Guid.empty.equals(businessType.id)) {
            this.dataService.getSection(this.baseEndpoint, "/?BusinessType_TId=" + businessType.id).then((data: any) => {
                this.selectedSection.model = data;
                this.selectedSection.activate();

                if (this.selectedSection.isPrimarySection) {
                    this.initializeHeader(data);
                }
                this.selectedSection.model.businessType_TId = businessType.id;
                this.loadTemplateNotification(businessType.id);
            }).finally(() => { this.loadingInProgress = false });
        }
        else {
            var fetchAssignedPhoneNumber = !this.isApplicationModeCO() && this.selectedSection.sectionId == 0 /* Main */ ? true : false;

            this.dataService.getSection(this.baseEndpoint, "/?fetchAssignedPhoneNumber=" + fetchAssignedPhoneNumber).then((data: any) => {
                this.selectedSection.model = data;
                this.selectedSection.activate();

                if (this.selectedSection.isPrimarySection) {
                    this.initializeHeader(data);
                }
                this.selectedSection.model.businessType_TId = null;
                this.loadTemplateNotification(null);
            }).finally(() => { this.loadingInProgress = false });
        }
    }

        getBusinessType(): void {
          this.$http({
            url: "/api/businesstype/List/",
            method: "POST",
            headers: { "Content-Type": "application/json;charset=UTF-8" },
            data: { "pageNumber": 0, "itemsPerPage": 20, "criteria": { IncludeAllLocationsListItem: false, "filter": "%" }, "asLocationId": null }
          }).then(response => {

                this.businessType = response.data;
            var item = {
                 "externalId": "AllBusinessTypes",
                 "isForAllLocations": false,
                 "objectState": 2026,
                 "objectCreationType": 0,
                 "id": emptyGuid(),
                 "locationId": 0,
                 "displayName": "All Business Types"
            };
            var businesTypeTemp = [];
            businesTypeTemp.push(item);
            businesTypeTemp.push(...this.businessType);
            this.businessType = businesTypeTemp;
            this.businessType_TId = Model.Guard.isSomething(this.businessType_TId) ? this.businessType_TId : this.businessType[0];

                if(this.isApplicationModeCO())
                    this.loadTemplateNotification(this.businessType_TId.id);
                else {
                    this.loadTemplateNotification(null);
                }
          });
      }

      getBusinessInfo(): void {
          this.dataService.customMethodData(`/api/Tenant/BusinessInfo`, "get", null).then(response => {
              this.businessInfo = response.data;
          });
      }

      getSettings(settingsType: Model.BusinessSettingCategoryEnum, includeMetadata: boolean = true): ng.IPromise<any> {
          return this.dataService.customMethodData(`/api/Settings/${Model.BusinessSettingCategoryEnum[settingsType]}?includeMetadata=${includeMetadata}`, 'GET', null).then((response) => {
              if (settingsType === Model.BusinessSettingCategoryEnum.Notification) {
                  this.businessSettings = response.data;
              }
              else if (settingsType === Model.BusinessSettingCategoryEnum.Clients) {
                  this.isBulkUpdateAllowed = response.data.allowNotificationSettingsBulkUpdate;
              }
          });
      }

      loadTemplateNotification(busnessTypeId?: any): void {
          var levelSetting = null;
          /*if (this.isApplicationModeCO() && busnessTypeId != "00000000-0000-0000-0000-000000000000")
              levelSetting = null;
          else if (this.isApplicationModeCO() && busnessTypeId == "00000000-0000-0000-0000-000000000000"){
              levelSetting = null;
          }*/
          if (this.isApplicationModeCO()) {
              if (busnessTypeId === Guid.empty || busnessTypeId == null || busnessTypeId == '00000000-0000-0000-0000-000000000001' || busnessTypeId == "00000000-0000-0000-0000-000000000000")
                  levelSetting = null;
              else levelSetting = Meevo.Model.LevelSettingEnum.BusinessType;
          } else levelSetting = Meevo.Model.LevelSettingEnum.Location;

           this.loading = true;
              this.$http({
                  url: "/api/Template/List/",
                  method: "POST",
                  headers: { "Content-Type": "application/json;charset=UTF-8" },
                  data: {
                      "pageNumber": 0,
                      "itemsPerPage": 25,
                      "sortDirection": 0,
                      "criteria": {
                          LevelSetting: levelSetting,
                          BusinessTypeId: busnessTypeId,
                          coBusinessTypeId: null,
                          coFilterByLocationId: null,
                          coSearchResultFilter: 0,
                          coSearchType: 0,
                          filter: "",
                          includeActive: true,
                          location: null
                      }
                  }
              }).then(response => {

                  this.templateNotifcations = response.data;
                  var defaultTemp = {
                      "typeId": 0,
                      "objectState": 2026,
                      "displayName": 'Use default template',
                      "id": emptyGuid()
                  };

                  if (busnessTypeId == undefined || busnessTypeId == null || busnessTypeId.equals(Guid.empty))
                      this.templateNotifcations = _.filter(this.templateNotifcations,
                        function (notification) { return !notification.hasOwnProperty('businessTypeId'); });
                  //else this.templateNotifcations = _.where(this.templateNotifcations, { busnessTypeId: busnessTypeId });

                  var temp = [];
                  temp.push(defaultTemp);
                  temp.push(...this.templateNotifcations);
                  this.templateNotifcations = temp;
                setTimeout(function () {
                          $("body")
                              .trigger("click"); // force the UI to detect the asynchronous watcher changes
                      },
                      750);

            }).finally(() => { this.loading = false; });
        }

        sort = { sortBy: null, sortDirection: Model.SortDirection.Descending };
        criteria = {};

        businessTypeFilter = {
            criteria: this.criteria,
            sortBy: this.sort.sortBy,
            sortDirection: this.sort.sortDirection
          }

      settingFilter = function (filter) {
          return function (obj) {
              return (
                  (obj.typeId == filter.typeId || obj.typeId == 0) &&
                    ((filter.businessType_TId == undefined && obj.businessType_TId == undefined) ||
                      (filter.businessType_TId == obj.businessType_TId))
              );
          };
      };

      processNotificationChange(notification: any): void {
          if (!notification.isNotificationEnabled) {
              notification.isEmailEnabledCurrentLevel = false;
              notification.isEmailEnabledDefault = false;
              notification.isSmsEnabledCurrentLevel = false;
              notification.isSMSEnabledDefault = false;
          } else if (notification.isNotificationEnabled) {
              notification.isEmailEnabledCurrentLevel = true;
              notification.isEmailEnabledDefault = false;
              notification.isSmsEnabledCurrentLevel = true;
              notification.isSMSEnabledDefault = false;
          }
      }

      determineIfEnabled(notification): boolean {
        if (this.isApplicationModeCO()) {
            return notification.isEmailEnabledCurrentLevel ||
                notification.isEmailEnabledDefault ||
                notification.isSmsEnabledCurrentLevel ||
                notification.isSMSEnabledDefault;
        } else {
            return notification.isEmailEnabledCurrentLevel ||
              notification.isSmsEnabledCurrentLevel;
        }
      }

      disableEmailNotification(isEmailEnabled: boolean): void {

          if (!isEmailEnabled) {
              this.selectedSection.model.communicationTypeNotifications.forEach(function (notification) {
                  notification.isEmailEnabledCurrentLevel = false;
              });
          }
          else {
              this.selectedSection.model.communicationTypeNotifications.forEach(function (notification) {
                  notification.isEmailEnabledCurrentLevel = true;
              });
          }
      }

      disableSmsNotification(isSmsEnabled: boolean): void {

          if (!isSmsEnabled) {
              this.selectedSection.model.communicationTypeNotifications.forEach(function (notification) {
                  notification.isSmsEnabledCurrentLevel = false;
                  notification.isCallEnabledCurrentLevel = false;
              });
          }
          else {
              this.selectedSection.model.communicationTypeNotifications.forEach(function (notification) {
                  notification.isSmsEnabledCurrentLevel = true;
                  notification.isCallEnabledCurrentLevel = true;
              });
          }
      }

      hasHigherLevel(settingLevel: number): boolean {
          //console.log('settingLevel', settingLevel, settingLevel === 2121 || settingLevel === 2122)
          return (settingLevel === 2121 || settingLevel === 2122) ? true : false;
      }

      loadSendDaysBeforeList(communicationType: Model.CommunicationTypeEnum, sendDaysBeforeDefault: any): void {
          if (communicationType === Model.CommunicationTypeEnum.AppointmentConfirmation) {
              this.apptConfirmationSendDaysBeforeList = [1, 2, 3, 4, 5, 6, 7];

              // Adding sendDaysBeforeDefault value, if other than range 1-7.
              if (!this.apptConfirmationSendDaysBeforeList.some(x=> x === sendDaysBeforeDefault)) {
                  this.apptConfirmationSendDaysBeforeList.push(sendDaysBeforeDefault);
                  this.apptConfirmationSendDaysBeforeList.sort((n1, n2) => n1 - n2);
              }
          }
          else if (communicationType === Model.CommunicationTypeEnum.AppointmentReminderDaysBefore) {
              this.apptReminderSendDaysBeforeList = [1, 2, 3, 4, 5, 6, 7];

              // Adding sendDaysBeforeDefault value, if other than range 1-7.
              if (!this.apptReminderSendDaysBeforeList.some(x=> x === sendDaysBeforeDefault)) {
                  this.apptReminderSendDaysBeforeList.push(sendDaysBeforeDefault);
                  this.apptReminderSendDaysBeforeList.sort((n1, n2) => n1 - n2);
              }
          }
      }


      getCommunicationTypeOptionsSettingCurrentLevel(options: any, displayName): boolean {

          var data = options.settings.filter(x => x.displayName == displayName)[0].metadata;

          var result = null;
          if (this.isApplicationModeCO()) {
              if (this.businessType_TId.id == null) {
                  result = data.tenantValue;
              }
              else {
                  result = data.businessValue;
              }
          }
          else {
              result = data.locationValue;
          }

          // System/Tenant/Business/Location value are by default string
          // Though, need to return boolean result for below settings
          if (data.settingId == this.clientAppointmentConfirmationOptionsSettings.isRescheduleEnabled ||
              data.settingId == this.clientAppointmentConfirmationOptionsSettings.isCancellationEnabled)
              return result == 1 ? true : false;

          return result;
      }

      get canSaveNotificationSettings(): boolean {
          return this.canSave && !this.loadingInProgress;
      }

      save(): angular.IPromise<any>
      {

          if (!this.selectedSection.model.isBulkUpdateSettingEnabled) {
              if (this.canSaveNotificationSettings) {
                  return super.save();
              }
          }
          else {

              var showWarning = false;
              var originalBulkUpdateSetting: any = this.originalModelNotificationSetting.bulkUpdateSetting;
              var updatedBulkUpdateSetting: any = this.selectedSection.model.bulkUpdateSetting;

              if (originalBulkUpdateSetting == undefined ||
                  (originalBulkUpdateSetting &&
                       (originalBulkUpdateSetting.isBulkEmailOptInUpdated != updatedBulkUpdateSetting.isBulkEmailOptInUpdated ||
                        originalBulkUpdateSetting.isBulkSMSOptInUpdated != updatedBulkUpdateSetting.isBulkSMSOptInUpdated ||
                        originalBulkUpdateSetting.isBulkSendSMSOptInUpdated != updatedBulkUpdateSetting.isBulkSendSMSOptInUpdated ||
                        originalBulkUpdateSetting.communicationType != updatedBulkUpdateSetting.communicationType ||
                        originalBulkUpdateSetting.bulkUpdateType != updatedBulkUpdateSetting.bulkUpdateType ||
                        originalBulkUpdateSetting.isBulkEmailUpdated != updatedBulkUpdateSetting.isBulkEmailUpdated ||
                        originalBulkUpdateSetting.isBulkSMSUpdated != updatedBulkUpdateSetting.isBulkSMSUpdated ||
                        originalBulkUpdateSetting.isBulkSendDaysUpdated != updatedBulkUpdateSetting.isBulkSendDaysUpdated))) {
                  showWarning = true;
                }

              if (showWarning) {
                  this.modalService.confirm('LABEL_NOTIFICATION_SETTINGS_WARNING_BULKUPDATE')
                      .then(response => {
                          if (!!response && this.canSaveNotificationSettings) {
                            return super.save();
                          }
                      });
              }
              else {
                  if (this.canSaveNotificationSettings) {
                      return super.save();
                  }
              }
          }
              
      }

      postUpdate(model: any): void {
          super.postUpdate(model);
          this.originalModelNotificationSetting = angular.copy(this.selectedSection.model);
      }


  }
}